module.exports = __webpack_public_path__ + "img/invitation.1cf26bfd.png";